import { Col, Row } from 'antd';
import React, { ReactElement } from 'react';
import Panel from '../../../shared/components/card/Panel';
import PanelCollapse from '../../../shared/components/collapse/PanelCollapse';
import PageHeader from '../../../shared/components/pageHeader/PageHeader';
import { GUTTOR_SPACE, GUTTOR_SPACE_SMALL } from '../../../shared/constants/commonConstants';
import { ReactComponent as MailIcon } from '../../../assets/images/svg/i_mail.svg';

const Help = (): ReactElement => {
  return (
    <>
       <PageHeader colSize={18}
        pageTitle="Help"
      />
      <div className="ant-tabs-content-holder tab-custom-container resources">
        <Row gutter={GUTTOR_SPACE} className="width-size1">
          <Col md={16}>
            <Panel title="FAQs" className="help">
              <PanelCollapse
                accordion={true}
                expandIconPosition="right"
                defaultActiveKey={[1]}
                keyName="1"
                header="Who can use IHX?"
              >
                <p>
                  In a medical centre, IHX can be used by multiple teams based
                  on their roles and areas of concern. The main teams for which
                  IHX can be useful are:
                </p>
                <ul className="mb-0">
                  <li>
                    <strong>Higher Management (CxO):</strong> Hospital insights,
                    Administration, User management.
                  </li>
                  <li>
                    <strong>Insurance Team:</strong> Claims management
                  </li>
                  <li>
                    <strong>Front desk team:</strong> Appointment management
                  </li>
                  <li>
                    <strong>Marketing or Sales Team:</strong> Profile
                    configuration and management
                  </li>
                  <li>
                    <strong>Finance Team:</strong> Financial reconciliation
                  </li>
                  <li className="mb-0">
                    <strong>Customer Support/ Out-patient help desk: </strong>{' '}
                    Appointment management
                  </li>
                </ul>
              </PanelCollapse>
              <PanelCollapse
                accordion={true}
                expandIconPosition="right"
                keyName="2"
                header="What can I use IHX for?"
              >
                <ol>
                  <li>Claims management</li>
                  <li>Profile configuration and management</li>
                  <li>Financial reconciliation</li>
                  <li>Appointment management</li>
                </ol>
              </PanelCollapse>
              <PanelCollapse
                accordion={true}
                expandIconPosition="right"
                keyName="3"
                header="How does IHX help in my operations?"
              >
                <ol>
                  <li>
                    Insurance team can login to IHX to submit and manage all
                    insurance claims in a single platform and get a real time
                    update on all the claims status.{' '}
                  </li>
                  <li>
                    Front desk team will get all appointment details in a single
                    window, help them plan the resources for upcoming days and
                    also see daily appointments for fulfillments.{' '}
                  </li>
                </ol>
              </PanelCollapse>
              <PanelCollapse
                accordion={true}
                expandIconPosition="right"
                keyName="4"
                header="Why should I configure a hospital profile on IHX?
                "
              >
                <ol>
                  <li>
                    The healthcare market in India has potential customers who
                    look for their preferred healthcare service. Profile
                    configuration is a feature on IHX that helps you to make
                    sure that your medical centre appears in their search
                    results.
                  </li>
                  <li>
                    You can upload your doctors, room types, health checks and
                    hospital facilities and images on IHX. A detailed profile
                    page can help you showcase everything that a potential
                    customer would want to know before they make their final
                    choice.
                  </li>
                  <li>
                    The customer will be able to view the facilities, doctors,
                    health checks and room types available at your hospital and
                    they will be able to book doctor appointments and health
                    checks online and also select the preferred room types at
                    your medical centre.
                  </li>
                  <li>
                    Profile configuration will increase the medical centre
                    visibility and thus increase the foot falls.
                  </li>
                </ol>
              </PanelCollapse>
              <PanelCollapse
                accordion={true}
                expandIconPosition="right"
                keyName="5"
                header="What happens if I configure the room-types on IHX?"
              >
                <ol>
                  <li>
                    You can upload pictures of the types of rooms available
                    along with images and tariffs on IHX.
                  </li>
                  <li>
                    This will help the customers to select their preferred room
                    type for any planned admission.
                  </li>
                  <li>
                    The room-types will also come as a drop-down menu while
                    filling the New Admission form and save your time.
                  </li>
                </ol>
              </PanelCollapse>
              <PanelCollapse
                accordion={true}
                expandIconPosition="right"
                keyName="6"
                header="What happens if I configure the doctors in my hospital?"
              >
                <ol>
                  <li>
                    You can provide the details about your specialists and
                    schedule appointments based on their timings and
                    availability.
                  </li>
                  <li>
                    Showcasing your team of doctors will help patients schedule
                    appointments with ease.
                  </li>
                  <li>
                    This will in-turn result in the increase of the foot-falls
                    at your medical centre.
                  </li>
                  <li>
                    The doctor’s names list will also come as a drop-down menu
                    in the New Admission form, which will help you save time.
                  </li>
                </ol>
              </PanelCollapse>
              <PanelCollapse
                accordion={true}
                expandIconPosition="right"
                keyName="7"
                header="Why should I configure the health checks available at my hospital?"
              >
                <ol>
                  <li>
                    You can create a catalogue of health check packages
                    including tests; tariffs etc. on IHX and schedule the same
                    as per slot availability.
                  </li>
                  <li>
                    You can also confirm appointments made by your customers on
                    IHX.
                  </li>
                </ol>
              </PanelCollapse>
              <PanelCollapse
                accordion={true}
                expandIconPosition="right"
                keyName="8"
                header="Why should I configure the facilities on IHX?"
              >
                <ol>
                  <li>
                    You should configure the facilities on IHX to showcase your
                    hospital’s best-in-class medical and general facilities to
                    the customers.
                  </li>
                  <li>
                    If the customer’s preferred amenity will be present at your
                    medical centre, then they will definitely select you over
                    the other choices.
                  </li>
                </ol>
              </PanelCollapse>
              <PanelCollapse
                accordion={true}
                expandIconPosition="right"
                keyName="9"
                header="Why should I configure my hospital’s location on IHX?"
              >
                <ol>
                  <li>Update your location on the map so that: </li>
                  <ol className="roman">
                    <li>
                      You can make your healthcare centre visible during map
                      searches.
                    </li>
                    <li>
                      Customers can find you easily through a quick network
                      hospital search.
                    </li>
                    <li>
                      Customers can find you with just a click on their
                      smartphone.
                    </li>
                  </ol>
                </ol>
              </PanelCollapse>
              <PanelCollapse
                accordion={true}
                expandIconPosition="right"
                keyName="10"
                header="How does a finance team benefit from IHX?"
              >
                <ol>
                  <li>
                    Team can view consolidated outstanding and settled status on
                    the platform for a given period.{' '}
                  </li>
                  <li>
                    Finance team can download real time outstanding and settled
                    data from IHX for reconciliation activities.
                  </li>
                </ol>
              </PanelCollapse>
              <PanelCollapse
                accordion={true}
                expandIconPosition="right"
                keyName="11"
                header="I forgot my password. How can I retrieve it?"
              >
                <ol>
                  <li>
                    You can retrieve your password by following the steps below:
                  </li>
                  <ol className="roman">
                    <li>Open IHX</li>
                    <li>
                      Click on <strong>Forgot password</strong>
                    </li>
                    <li>
                      In the pop-up box, enter your username/ registered email
                      ID
                    </li>
                    <li>Then click on Reset Password</li>
                    <li>
                      You will receive a mail with the link to reset the
                      password on your registered email ID
                    </li>
                    <li>
                      Please click on the link in that mail and enter the
                      password you want to keep
                    </li>
                  </ol>
                </ol>
              </PanelCollapse>
              <PanelCollapse
                accordion={true}
                expandIconPosition="right"
                keyName="12"
                header="How can I customize my dashboard?"
              >
                <ol>
                  <li>
                    You can customize your dashboard to view real-time claims
                    summary, the way you see fit.
                  </li>
                  <li>
                    Go to Dashboard → Click on the settings icon at the top
                    right corner → Tick the headers that you want to keep →
                    Click on save
                  </li>
                </ol>
              </PanelCollapse>
              <PanelCollapse
                accordion={true}
                expandIconPosition="right"
                keyName="13"
                header="Is IHX the same as MediBuddy+?"
              >
                <ol>
                  <li>
                    MediBuddy+ was a platform developed for hospitals to manage
                    claims of Medi Assist alone, whereas IHX is a one stop
                    solution to assist hospitals to connect to other players in
                    the ecosystem.
                  </li>
                </ol>
              </PanelCollapse>
              <PanelCollapse
                accordion={true}
                expandIconPosition="right"
                keyName="14"
                header="How can I contact the IHX team?"
              >
                <ol>
                  <li>
                    You can contact us anytime using the Mailbox on IHX. A
                    ticket number will be generated. You can check the reverts
                    and the status of the ticket in the Mailbox itself.
                  </li>
                  <li>
                    Please write to <a href="mailto:care@ihx.in">care@ihx.in</a>
                    , the team will get back to you at the earliest.{' '}
                  </li>
                </ol>
              </PanelCollapse>
            </Panel>
          </Col>
          <Col md={8}>
            <Panel title="Reach us">
              <Row gutter={GUTTOR_SPACE_SMALL}>
                <Col md={24}> <a href="mailto:care@ihx.in">
                  <MailIcon className="fill-primary v-align-middle" /> care@ihx.in</a></Col>
              </Row>
            </Panel>
          </Col>
        </Row>
      </div>
      </>
  );
};

export default Help;
